import { NodeViewWrapper } from '@tiptap/react';
import { useCallback, useMemo, useRef, useState } from 'react';

export default function GalleryNodeView({ node, updateAttributes, selected, editor }) {
  const images = useMemo(() => node.attrs.images || [], [node.attrs.images]);
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const addImage = useCallback(() => {
    if (editor?.uploadImage) {
      fileInputRef.current?.click();
    } else {
      const src = window.prompt('Image URL', '/img/news/');
      if (!src) return;
      const alt = window.prompt('Alt text (optional)', '') || '';
      updateAttributes({ images: [...images, { src, alt }] });
    }
  }, [images, updateAttributes, editor]);

  const handleFile = useCallback(async (file) => {
    if (!editor?.uploadImage || !file) return;
    setUploading(true);
    setUploadError(null);
    try {
      const url = await editor.uploadImage(file);
      updateAttributes({ images: [...images, { src: url, alt: '' }] });
    } catch (err) {
      setUploadError(`Upload failed: ${err.message}`);
    } finally {
      setUploading(false);
    }
  }, [editor, images, updateAttributes]);

  const removeImage = useCallback((index) => {
    updateAttributes({ images: images.filter((_, i) => i !== index) });
  }, [images, updateAttributes]);

  return (
    <NodeViewWrapper>
      <div className={`post-gallery border-2 rounded transition-colors ${selected ? 'border-bahyellow' : 'border-gray-200'}`}>
        {images.map((img, i) => (
          <div key={i} className="relative group">
            <img src={img.src} alt={img.alt} />
            <button
              type="button"
              onClick={() => removeImage(i)}
              className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity leading-none"
            >
              ✕
            </button>
          </div>
        ))}
        <div className="m-1.5 flex flex-col items-center gap-1">
          <button
            type="button"
            onClick={addImage}
            disabled={uploading}
            className="h-24 w-32 border-2 border-dashed border-gray-300 rounded text-gray-400 hover:border-bahyellow hover:text-bahyellow transition-colors text-sm disabled:opacity-50"
          >
            {uploading ? 'Uploading…' : '+ Add image'}
          </button>
          {uploadError && <span className="text-xs text-red-500">{uploadError}</span>}
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => { const f = e.target.files[0]; if (f) handleFile(f); e.target.value = ''; }}
        />
      </div>
    </NodeViewWrapper>
  );
}
